import { IWorkOrderPrintData } from "core/types/entities/IWorkOrderPrintData";

const hasNumber = (source: Record<string, unknown>, key: string): boolean =>
  typeof source[key] === "number";

/**
 * Narrows the print endpoint's response at the boundary: the printed sheet states money
 * totals, so an unrecognised payload must fail loudly instead of printing zeros.
 */
export const isWorkOrderPrintData = (value: unknown): value is IWorkOrderPrintData => {
  if (typeof value !== "object" || value === null) return false;

  const candidate = value as Record<string, unknown>;

  return (
    hasNumber(candidate, "totalNonItemExpenses") &&
    hasNumber(candidate, "totalItemExpenses") &&
    hasNumber(candidate, "workOrderTotal")
  );
};
